import adminDashboard from "@/store/modules/notifications/admin-dashboard";
import profilePreview from "@/store/modules/notifications/profile-preview";

export default {
    namespaced: true,
    modules: {
        adminDashboard,
        profilePreview,
    },
};
